<template>
  <div>
    <terminal-table
        class="col-12"
        :currentPage="data.current_page"
        :perPage="data.per_page" v-if="isMobile"
        :getData="fetchData"
        :pageCount="data.last_page"
        :options="tbProps" :datas="data" :headers="columns"/>

    <data-table
        v-if="!isMobile"
        :data="data"
        @row-clicked="rowClicked"
        :columns="columns"
        :debounce-delay="3000"
        :translate="translate"
        :pagination="paginate"
        :orderDir="tbProps.dir"
        :per-page="[10, 25, 50, 100, 500]"
        @on-table-props-changed="reloadTable"
        class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs">
      <template slot="filters">
        <filters-table v-model="tbProps"/>
      </template>
    </data-table>
  </div>
</template>

<script>
import {dataTableProps} from "@/main";
import FiltersTable from "./filtersTable.vue";

export default {
  name: "MixedTable",
  components: {FiltersTable},
  props: {
    fetchData: {
      type: Function,
      required: true,
    },
    reloadTable: {
      type: Function,
      required: true,
    },
    columns: {
      required: true
    },
    data: {
      required: true
    },
    tbProps: {
      required: true
    },
    rowClicked: {
      type: Function,
      default() {
        return () => {
        }
      }
    }
  },
  data() {
    return {
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      time: undefined
    }
  },
  watch: {
    tbProps: {
      deep: true,
      handler() {
        this.reloadTable();
      }
    }
  },
  computed: {
    isMobile() {
      clearTimeout(this.time);

      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.time = setTimeout(() => {
            this.fetchData();
          }, 700);
          return true
        case 'sm':
          this.time = setTimeout(() => {
            this.fetchData();
          }, 700);
          return true
        case 'md':
          this.time = setTimeout(() => {
            this.fetchData();
          }, 700);
          return false
        case 'lg':
          this.time = setTimeout(() => {
            this.fetchData();
          }, 700);
          return false
        case 'xl':
          this.time = setTimeout(() => {
            this.fetchData();
          }, 700);
          return false
      }

    },
  },
}
</script>

<style scoped>

</style>